export default function useDefaultChartOptions() {
    return {
        boost: {
            enabled: false,
        },
        chart: {
            backgroundColor: 'rgba(0,0,0,0)',
        },
        credits: {
            enabled: false,
        },
    };
}
